module.exports = __webpack_public_path__ + "static/img/wdxz.8af1ce8d.png";